import { useState } from 'react';

import { useInfiniteQuery } from 'react-query';

import { getAttendUsers } from '@api/attend';
import type { GetAttendUsersQuery } from '@api/attend/getAttendUsers';

function useGetAttendUsers(path: { groupEventId: number }, props?: Partial<GetAttendUsersQuery>) {
  const [total, setTotal] = useState<number>(0);

  const response = useInfiniteQuery(
    ['ATTEND_USERS', props?.page, props?.dir, props?.q, props?.isDelegator],
    async ({ pageParam: page = 1 }) => {
      const query: GetAttendUsersQuery = {
        page,
        limit: props?.limit ? 1000 : 8,
        dir: 'desc',
        ...props,
      };

      const response = await getAttendUsers({ path, query });

      console.log({ query, response });

      if (response) setTotal(response.count);

      return response;
    },
    {
      getNextPageParam: (_, pageParam) => {
        const result = pageParam.length + 1;
        return result;
      },
      getPreviousPageParam: (_, pageParam) => {
        const result = pageParam.length - 1;
        return result || 1;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );

  const data =
    response.data?.pages?.filter(v => v)?.flatMap(data => (data ? data?.rows?.map(v => v) : [])) ||
    [];

  return { ...response, data, total };
}

export default useGetAttendUsers;
